module.exports = __webpack_public_path__ + "static/media/green-roofs-logo-leaf.41eb8d90.svg";